exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".location-unknown-details{display:flex;flex-flow:row wrap}.location-unknown-details .status-change-item{flex:0 0 auto;width:calc(99.99% * 1/2 - 10px)}.location-unknown-details .status-change-item:nth-child(1n){margin-right:20px}.location-unknown-details .status-change-item:last-child{margin-right:0}.location-unknown-details .status-change-item:nth-child(2n){float:right;margin-right:0}.location-unknown-details .status-change-item .react-datepicker__input-container{-ms-flex:0 0 100%;flex:0 0 100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/status-change-request/components/additional-fields-views/location-unknown-status-details.scss
// module id = 5157
// module chunks = 0